<template>
    <div>
        <button class="btn btn-large editDialogButton" @click.prevent="openWindow()">{{asString}}</button>
        <b-modal ref="query-modal" class="in" @shown="afterOpen" @ok="handleOK" :no-close-on-backdrop="true">
            <template v-slot:modal-header>
                <h3>Edit query</h3>
            </template>
            <vue-query-builder :rules="rules" v-model="query2" :maxDepth="5" />
            <button @click.prevent="log">Log</button>
        </b-modal>
    </div>
</template>

<script>
import VueQueryBuilder from "vue-query-builder";
import {formatQueryBuilderGroup, createQueryBuilderGroup, queryToString} from "../queryBuilderAdapter";
export default {
	props: ["value"],
	components: {VueQueryBuilder},
	data: () => ({
		rules: [
			{type: "text", id: "dnumber", "label": "dnumber"},
			{type: "text", id: "snumber", "label": "snumber"},
			{type: "text", id: "cnumber", "label": "cnumber"},
			{type: "text", id: "queue_status", "label": "queue status (internal)"},
			{type: "text", id: "callerid_external", "label": "callerid external"},
			{type: "text", id: "extension", "label": "extension"},
			{type: "numeric", id: "talktime", "label": "talk time"},
			{type: "numeric", id: "totaltime", "label": "total time"},
			{type: "select",
				id: "direction",
				"label": "direction",
				operators: ["equals"],
				choices: [
					{label: "inbound", value: "inbound"},
					{label: "outbound", value: "outbound"}
				]}
		],
		query2: null
	}),
	methods: {
		openWindow() {
			this.query2 = createQueryBuilderGroup(this.value || {});
			let modal = this.$refs["query-modal"];
			modal.show();
		},
		afterOpen(event) {
			event.vueTarget.$refs.modal.classList.add("in");
		},
		handleOK() {
			// this.query = formatQueryBuilderGroup(this.query2);
			this.$emit("input", formatQueryBuilderGroup(this.query2));
		},
		log() {
			console.info(this.query2);
			console.info(formatQueryBuilderGroup(this.query2));
		}
	},
	computed: {
		asString() {
			let asString = queryToString(this.value);
			return (asString == "" || asString == null) ? "<No Filter>" : asString;
		}
	}
};
</script>

<style lang="scss" scoped>
.vue-query-builder /deep/{
    @import url('../../../styles/query-builder.scss');
}
.editDialogButton:hover {
    // width: auto !important;
    white-space: normal;
}
</style>